const { createClient } = require("@supabase/supabase-js");

export const supabase = createClient(
'https://torldnxecubuyagzqopq.supabase.co',
'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRvcmxkbnhlY3VidXlhZ3pxb3BxIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NTY3MjA3MDYsImV4cCI6MTk3MjI5NjcwNn0.RZZepX6g-yp1thGlyoK4pP9HagQalvA8y8n3QsENI_w'
);

